import { z } from 'zod';

var OnboardingCode;
(function (OnboardingCode) {
    OnboardingCode["RENA_OMNI_PROGRAM_2025"] = "RENA_OMNI_PROGRAM_2025";
    OnboardingCode["LIVEWIRE_OMNI_PROGRAM_2025"] = "LIVEWIRE_OMNI_PROGRAM_2025";
    OnboardingCode["TEST_PROGRAM"] = "TEST_PROGRAM";
    OnboardingCode["EKHO_ACCESS_OEM_PROGRAM"] = "EKHO_ACCESS_OEM_PROGRAM";
    OnboardingCode["EKHO_OMNI_OEM_PROGRAM"] = "EKHO_OMNI_OEM_PROGRAM";
    OnboardingCode["EVIN_MOTORS_NC"] = "EVIN_MOTORS_NC";
    OnboardingCode["EVIN_MOTORS_FL"] = "EVIN_MOTORS_FL";
    OnboardingCode["EUROCYCLE"] = "EUROCYCLE";
    OnboardingCode["CCW"] = "CCW";
    OnboardingCode["CARTMART"] = "CARTMART";
    OnboardingCode["UBD"] = "UBD";
    OnboardingCode["GENERIC_PROGRAM_OWNER"] = "GENERIC_PROGRAM_OWNER";
    OnboardingCode["MASSIMO"] = "MASSIMO";
    OnboardingCode["STAREV"] = "STAREV";
    OnboardingCode["BDC_DEALER"] = "BDC_DEALER";
})(OnboardingCode || (OnboardingCode = {}));
const onboardingCodeValues = [
    OnboardingCode.RENA_OMNI_PROGRAM_2025,
    OnboardingCode.LIVEWIRE_OMNI_PROGRAM_2025,
    OnboardingCode.TEST_PROGRAM,
    OnboardingCode.EKHO_ACCESS_OEM_PROGRAM,
    OnboardingCode.EKHO_OMNI_OEM_PROGRAM,
    OnboardingCode.EVIN_MOTORS_NC,
    OnboardingCode.EVIN_MOTORS_FL,
    OnboardingCode.EUROCYCLE,
    OnboardingCode.CCW,
    OnboardingCode.CARTMART,
    OnboardingCode.UBD,
    OnboardingCode.GENERIC_PROGRAM_OWNER,
    OnboardingCode.MASSIMO,
    OnboardingCode.STAREV,
    OnboardingCode.BDC_DEALER,
];
const onboardingCodeSchema = z.enum(onboardingCodeValues);

export { OnboardingCode, onboardingCodeSchema };
//# sourceMappingURL=OnboardingCode.js.map
